import { Components } from '@ionic/core/dist/types/components';
import { IonLabel, IonSelect, IonSelectOption, IonText } from '@ionic/react';
import { FieldConfig, useField } from 'formik';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { IonItem } from '../ionic/IonItem';

export type PicklistOption = { label: string; value: string | number };

export interface IonFormFieldProps extends FieldConfig {
  className?: string;
  label: string;
  selectProps?: Partial<Components.IonSelect>;
  options?: PicklistOption[];
}

const IonFormPicklistField = (props: IonFormFieldProps): ReactElement => {
  const { label, options, ...otherProps } = props;
  const { i18n } = useTranslation();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [field, meta, helper] = useField(otherProps as any);

  const selectProps = (otherProps.selectProps || {}) as Components.IonSelect;

  const errorText = <IonText color="danger">{meta.error}</IonText>;

  const sortedOptions: PicklistOption[] = options ?? [];

  let labelColor: string | undefined = 'primary';
  if (
    selectProps?.labelPlacement !== undefined &&
    selectProps?.labelPlacement !== 'floating'
  ) {
    labelColor = undefined;
  }

  return (
    <IonItem lines={'full'} className={props.className}>
      <IonSelect
        aria-label={label}
        labelPlacement="floating"
        {...selectProps}
        interface={'popover'}
        value={field.value}
        placeholder={i18n.t('common:make_a_selection')}
        onIonChange={(e) => {
          if (e.detail.value !== undefined) {
            helper.setValue(e.detail.value);
          }
        }}
      >
        <div slot="label">
          <IonLabel color={labelColor}>
            {label} {errorText}
          </IonLabel>
        </div>
        {sortedOptions.map((option, index) => {
          return (
            <IonSelectOption key={index} value={option.value}>
              {option.label}
            </IonSelectOption>
          );
        })}
      </IonSelect>
    </IonItem>
  );
};

export { IonFormPicklistField };
